module.exports = __webpack_public_path__ + "static/media/signage-industrial-img33.789d7833.jpg";